import React from 'react';
import { ErrorMessageTW } from '../../../tailwindComponents/errorMessage/ErrorMessageTW';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import { SerializedError } from '@reduxjs/toolkit';

export const CommentLayout: React.FC<{
  pageError?: FetchBaseQueryError | SerializedError;
  children: React.ReactNode;
}> = ({ pageError, children }) => {
  return (
    <div className={'pt-4'}>
      <ErrorMessageTW rtkError={pageError} />
      <div className={'flex flex-row gap-4'}>{children}</div>
    </div>
  );
};
